import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faCog, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';
import styles from '../PromptGenerator.module.css';

interface ModeToggleProps {
  isAdvancedMode: boolean;
  handleModeToggle: () => void;
}

const ModeToggle: React.FC<ModeToggleProps> = ({ isAdvancedMode, handleModeToggle }) => {
  const { t } = useTranslation('promptGenerator');
  
  return (
    <div className={styles.modeToggle}>
      <div className={styles.modeToggleContainer}>
        <span className={`${styles.modeLabel} ${!isAdvancedMode ? styles.active : ''}`}>
          <FontAwesomeIcon icon={faRocket} />
          {t('promptGenerator.modeToggle.quickMode')}
        </span>
        <button
          className={styles.toggleButton}
          onClick={handleModeToggle}
          title={isAdvancedMode ? t('promptGenerator.modeToggle.quickMode') : t('promptGenerator.modeToggle.advancedMode')}
        >
          <FontAwesomeIcon 
            icon={isAdvancedMode ? faToggleOn : faToggleOff} 
            className={`${styles.toggleIcon} ${isAdvancedMode ? styles.on : styles.off}`}
          />
        </button>
        <span className={`${styles.modeLabel} ${isAdvancedMode ? styles.active : ''}`}>
          <FontAwesomeIcon icon={faCog} />
          {t('promptGenerator.modeToggle.advancedMode')}
        </span>
      </div>
      <p className={styles.modeDescription}>
        {isAdvancedMode 
          ? t('promptGenerator.modeToggle.advancedDescription')
          : t('promptGenerator.modeToggle.quickDescription')
        }
      </p>
    </div>
  );
};

export default ModeToggle;